import createReducer from '../../../../../../../helpers/createReducer';
import { updateDonorSummaryReportSearchQuery } from '../../../../../actions/reports/donor-summary';

const initialState = {
  dateRange: [],
  inventoryLocationId: [],
  groupBy: []
};

const updateDonorSummaryReportSearchQueryHandler = action => ({
  [action.toString()]: (_, { payload: searchQuery }) => searchQuery
});

export default createReducer(initialState, {
  ...updateDonorSummaryReportSearchQueryHandler(
    updateDonorSummaryReportSearchQuery
  )
});
